import { Created, Deleted, Updated } from "./common";
import {
  IssueAdminEntityAttributes,
  IssueAdminEntityPermittedAttribute,
  IssueReorderableAdminEntityPermittedAction,
} from "./IssueAdminEntity";

// for the purposes of reordering and hiding fields,
// we need identifiers for all the standard fields.
// IMPORTANT NOTE:
// These are only identifiers for the fields that are shown in the UI,
// and should not be confused with the attributes on the issue object.
// Although some identifiers may be the same, these identifiers
// should not be conflated with the attributes on an issue.
export enum IssueStandardFieldIds {
  Description = "description",
  Assignee = "assignedTo",
  Watchers = "watchers",
  Location = "locationId",
  LocationDetails = "locationDetails",
  GpsCoordinates = "gpsCoordinates",
  DueDate = "dueDate",
  StartDate = "startDate",
  Placement = "linkedDocuments",
  RootCauseWithCategory = "rootCauseId",
  Attachments = "attachments",
  References = "relationships",
}

// type definitions: these describe the way the data in the payload should be
type CustomFieldId = string; // this would be the custom attribute definition id

export type IssueFieldId = IssueStandardFieldIds | CustomFieldId; // IssueStandardFieldIds are named based on the fields that exist in the UI

export interface FieldMetadataForTypes {
  type: "standard" | "custom";
  id: IssueFieldId;
  visible: boolean;
  required?: boolean;
}

interface IssueTypeCommon
  extends IssueAdminEntityAttributes,
    Created,
    Deleted,
    Updated {
  id: string;
  isActive: boolean;
  permittedActions: IssueReorderableAdminEntityPermittedAction[];
  permittedAttributes: IssueAdminEntityPermittedAttribute[];
}

export interface IssueType extends IssueTypeCommon {
  code?: string;
  fieldsMetadata?: FieldMetadataForTypes[];
  issueTypeCategoryId: string;
  isReadOnly: boolean;
}

export interface IssueTypeCategory extends IssueTypeCommon {
  projectId: string;
  types: IssueType[];
}
